import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import Slider from '@jeremyhamm/vue-slider';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import loader from 'vue-ui-preloader';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios'
import Print from 'vue-print-nb' // this npm for print any section in HTML page 
import GAuth from "vue-google-oauth2";


import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faInfo,
  faLock,
  faEnvelope,
  faPhoneAlt,
  faTransgender,
  faCalendar,
  faIdCard,
  faAddressBook,
  
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';


library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt,  faInfo, faLock, faEnvelope, faPhoneAlt, faTransgender, faCalendar, faIdCard,faAddressBook);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(require('vue-moment'));

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);
Vue.use(loader);
Vue.use(Slider);
Vue.use(Print);
Vue.prototype.$axios = axios

Vue.use(GAuth, {
  clientId:
    "796131519518-i1bsa6n92gb91crb1it5otoj650m2tah.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "consent",
  fetch_basic_profile: true,
  hd:'example@su.edu.eg'
});

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// to force Update

Vue.forceUpdate;
Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'EGP'
  });
  return formatter.format(value);
});

axios.interceptors.request.use(function (config) {
  const user =  JSON.parse(sessionStorage.getItem('user'));
 if(user != null ){
  config.headers.Authorization =  'Bearer ' + (user.token != null ? user.token : user.Token) ;
  config.withCredentials =  true ;

  return config;}
  else{
    config.withCredentials =  true;
       // console.log('header added')
    return config
  }
  
});
axios.interceptors.response.use(
  response => { 
    return response
    },
  error => {
    //console.log('error',error.response.status)
    // eslint-disable-next-line no-debugger
    debugger
    if(error.response != undefined){
      if(error.response.status != undefined){

        let  err = error.response.status
        if (err === 401) {
          store.dispatch('auth/logout');
          router.push('/login');
        }
      }
        

    } 

      return Promise.reject( error)
    
  });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
